/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:17:45
*/

import React from 'react';
import { setTimeout } from 'timers';

class SessionExpiredComponent extends React.Component{
  constructor(props) {
        super(props);
        this.state = {
          phoneNumber: "0"
        };
  };

  componentDidMount(){
      setTimeout(()=>{
        this.goToLoginPage();
        this.setState({phoneNumber:this.getUrlParameter("mobileNumber")})
      },3000);
  }

  goToLoginPage(){
    localStorage.removeItem("isUserLoggedIn");
    localStorage.removeItem("currentAccount");
    if (localStorage.getItem("isMobile")) {
      window.location.replace('/mobile=true&mobileNumber='+this.state.phoneNumber);
    } else {
        localStorage.removeItem("isMobile");
        window.location.replace('/');
    }
 };

  render(){
    const outerContainerStyle = {height: window.innerHeight  + 'px'};
        return (
            <div id="outerContainer" className="d-flex align-items-start justify-content-center animated fadeIn" style={outerContainerStyle}>
                 <div id="innerDiv" className="">   
                    <a id="innerDivMessage" onClick={() => this.goToLoginPage()}>Session Expired click to login again</a>
                </div>  
            </div>
        );
    }

}

export default SessionExpiredComponent;

